module.exports = __webpack_public_path__ + "img/SZ.363f6506.png";